// src/data/destinationsData.js
import ThailandImg from '../assets/images/thailand-1.jpg';
import SingaporeImg from '../assets/images/singapore-1.jpg';
import MalasiaImg from '../assets/images/malasia.jpg';
import GoaImg from '../assets/images/GoaDestination.jpg';
import ManaliImg from '../assets/images/manaliDestination.jpg';
import MaldivesImg from '../assets/images/MaldivesDestination.jpg';
import JaipurImg from '../assets/images/Jaipur.jpg';

const destinations = [
  {
    slug: "thailand",
    name: "Thailand",
    image: ThailandImg,
    description: "Thailand is a tropical paradise known for its beaches, temples, and street food.",
  },
  {
    slug: "singapore",
    name: "Singapore",
    image: SingaporeImg,
    description: "Singapore is a clean and vibrant city-state with a rich culture and skyline.",
  },
  {
    slug: "malasia",
    name: "Malasia",
    image: MalasiaImg,
    description: "Malasia is known for its rainforests, islands, and multicultural charm.",
  },
  {
    slug: "goa",
    name: "Goa",
    image: GoaImg,
    description: "Goa offers beautiful beaches, vibrant nightlife, and Portuguese heritage.",
  },
  {
    slug: "manali",
    name: "Manali",
    image: ManaliImg,
    description: "Manali is a peaceful mountain town perfect for adventure lovers.",
  },
  {
    slug: "maldives",
    name: "Maldives",
    image: MaldivesImg,
    description: "Maldives features white sand beaches, overwater bungalows, and coral reefs.",
  },
  {
    slug: "jaipur",
    name: "Jaipur",
    image: JaipurImg,
    description: "Jaipur, the Pink City, is rich with history, palaces, and Rajasthani culture.",
  },
];

export default destinations;
